export enum MedicationTypeEnum {
    TakeHomeScript='TakeHomeScript',
    MedicationOrder='MedicationOrder',
    MedicationHistory='MedicationHistory',
    AgedDisabilityScript='AgedDisabilityScript',
    ComplementaryTherapyOrder='ComplementaryTherapyOrder',
}